// Chaos Canvas Card effect numbers that both the server (the gallery's saved
// images) and the client (the live canvas) need to agree on.

export interface ForgetfulnessTiming {
  /** How long after a stroke is finished before it starts to fade. */
  delayMs: number;
  /** How long the fade to invisible then takes. */
  fadeMs: number;
}

/** Forgetfulness I fades strokes out after 30s, II after 15s. */
export function getForgetfulnessTiming(level: number): ForgetfulnessTiming {
  return level >= 2 ? { delayMs: 15_000, fadeMs: 5_000 } : { delayMs: 30_000, fadeMs: 10_000 };
}
